export default __webpack_public_path__ + "static/media/0FB5820D-6255-4AE4-90F5-4F59D3904599_1_105_c.aec58687.jpeg";